import { useId, type MouseEvent } from "react";
import "./cartridge-slot.css";

interface CartridgeSlotProps {
  title: string;
  state: "loading" | "ready" | "error";
  insertion: number;
  onChange(event: MouseEvent<HTMLButtonElement>): void;
}

export default function CartridgeSlot({ title, state, insertion, onChange }: CartridgeSlotProps) {
  const descriptionId = useId();
  const cartridgeTitle = title.trim() || "Game cartridge";

  return (
    <button
      className="cartridge-slot"
      type="button"
      aria-label="Change cartridge"
      aria-haspopup="dialog"
      aria-describedby={descriptionId}
      aria-busy={state === "loading"}
      data-state={state}
      data-insertion={insertion}
      onClick={onChange}
    >
      <span className="cartridge-bay-frame" aria-hidden="true" />
      <span className="cartridge-bay-recess" aria-hidden="true" />
      <span key={insertion} className="cartridge-shell" aria-hidden="true">
        <span className="cartridge-paper-label">
          <span className="cartridge-label-series">SERENDIPTV</span>
          <strong className="cartridge-label-title">{cartridgeTitle}</strong>
          <svg className="cartridge-label-art" viewBox="0 0 64 28" focusable="false">
            <path fill="currentColor" d="M4 22h56v2H4zM10 18h4v4h-4zm4-4h4v4h-4zm4-4h4v4h-4zM46 10h4v4h-4zm4 4h4v4h-4zm4 4h4v4h-4z" opacity=".38" />
            <path fill="#b05b37" d="M30 3h4v4h4v4h4v8h-8v-4h-4v4h-8v-8h4V7h4z" />
            <path fill="#324f51" d="M30 8h4v5h-4zM26 20h4v5h-4zm8 0h4v5h-4z" />
            <path fill="currentColor" d="M7 5h2v2h2v2H9v2H7V9H5V7h2zM54 4h2v2h2v2h-2v2h-2V8h-2V6h2z" />
          </svg>
          <span className="cartridge-label-format">8-BIT GAME PAK</span>
        </span>
        <span className="cartridge-grip" />
      </span>
      <span className="cartridge-slot-lip" aria-hidden="true">
        <span className="cartridge-slot-arrow">▼</span>
      </span>
      <span className="cartridge-slot-legend" aria-hidden="true">
        <span className="cartridge-status-light" />
        <span>{state === "loading" ? "INSERTING" : state === "error" ? "CHECK CARTRIDGE" : "CHANGE CARTRIDGE"}</span>
      </span>
      <span id={descriptionId} className="screen-reader-status">
        {cartridgeTitle}. {state === "loading" ? "Cartridge loading." : state === "error" ? "Cartridge needs attention." : "Cartridge inserted."} Open the cartridge tray to change games.
      </span>
    </button>
  );
}
